import { call, put, takeLatest } from 'redux-saga/effects';
import * as api from '../../api';
import * as actions from './actions';
import { showToast } from '../../components/toast/actions';

export function* getStudentsByUserProfileId({ productId, userProfileId }) {
    const payload = yield call(api.getStudentByUserProfileId, productId, userProfileId);
    if (payload.status === 200) {
        yield put(actions.getStudentsSuccess(payload));
    } else {
        yield put(actions.getStudentsFailure());
    }
}

export function* editStudentInformation({ student, context }) {
    const response = yield call(api.editStudent, student);
    if (response.status === 200) {
        yield put(actions.editStudentSuccess(context));
    } else if (response.status === 400 || response.status === 409) {
        yield put(actions.editStudentFailure(false, response.message, false));
        yield put(showToast(response.message, 'error'));
    } else {
        yield put(actions.editStudentFailure(true, ''));
    }
}

export function* getStudentsByUserProfileIdSaga() {
    yield takeLatest(actions.GET_STUDENTS_REQUEST, getStudentsByUserProfileId);
}

export function* unassignStudentsByClassId({ userProfileId, classId }) {
    const StudentDetail = {
        classroomId: classId,
        studentsProfileIdToUnassign: [userProfileId]
    };
    const response = yield call(api.unAssignStudents, StudentDetail);
    if (response.status === 200) {
        yield put(actions.unassignStudentsByClassIdSuccess());
    } else {
        yield put(actions.unassignStudentsByClassIdFailure());
    }
}

export function* unassignStudentsByClassIdSaga() {
    yield takeLatest(actions.UNASSIGN_STUDENTS_USING_CLASSID_REQUEST, unassignStudentsByClassId);
}

export function* editStudentSaga() {
    yield takeLatest(actions.EDIT_STUDENT_REQUEST, editStudentInformation);
}



// WEBPACK FOOTER //
// ./app/containers/edit-student/saga.js